"use strict";
import { PlainImage } from "ui/src/components/UniversalImage/internal/PlainImage";
export function FastImageWrapper({ setError: _, ...rest }) {
  return <PlainImage {...rest} />;
}
